import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal } from "./anim";
import { INSTAGRAM } from "./data";

const POSTS = [
  "/portfolio/kesar-1.jpg",
  "/portfolio/bishzu-4.jpg",
  "/portfolio/kesar-4.jpg",
  "/portfolio/bishzu-1.jpg",
  "/portfolio/kesar-5.jpg",
  "/portfolio/bishzu-3.jpg",
];

export const InstaFeed = () => (
  <section
    data-testid="instagram-section"
    className="relative mx-auto max-w-[1400px] px-6 py-28 md:px-10 md:py-36"
  >
    <div className="mb-12 flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
      <Reveal>
        <p className="mb-4 flex items-center gap-3 text-xs uppercase tracking-[0.3em] text-[hsl(var(--muted))]">
          <span className="h-px w-8 bg-[hsl(var(--primary))]" /> On Instagram
        </p>
        <h2 className="font-head text-4xl font-semibold leading-[1.02] sm:text-5xl lg:text-6xl">
          Fresh work, <span className="italic text-[hsl(var(--primary))]">daily.</span>
        </h2>
      </Reveal>
      <Reveal delay={0.15}>
        <a
          href={INSTAGRAM}
          target="_blank"
          rel="noreferrer"
          data-testid="instagram-follow-btn"
          className="group flex w-fit items-center gap-2 rounded-full bg-[hsl(var(--primary))] px-7 py-3.5 text-base font-semibold text-[hsl(var(--primary-fg))] transition-transform duration-300 hover:scale-105"
        >
          <Instagram size={18} /> Follow @designn_4_you
          <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </a>
      </Reveal>
    </div>

    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
      {POSTS.map((img, i) => (
        <Reveal key={img} delay={i * 0.06}>
          <motion.a
            href={INSTAGRAM}
            target="_blank"
            rel="noreferrer"
            whileHover={{ y: -5 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
            data-testid={`instagram-post-${i}`}
            className="group relative block aspect-square overflow-hidden rounded-xl border border-[hsl(var(--border))]"
          >
            <img
              src={img}
              alt={`Design4you on Instagram ${i + 1}`}
              loading="lazy"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
            />
            <span className="absolute inset-0 flex items-center justify-center bg-black/50 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
              <Instagram size={26} className="text-white" />
            </span>
          </motion.a>
        </Reveal>
      ))}
    </div>
  </section>
);
